// 提示类封装

const blurWrapper = function blurWrapper(fn) {
  return new Proxy(fn, {
    apply(target, object, args) {
      const elList = Array.from(document.querySelectorAll('button:focus,input:focus'));
      if (elList.length) {
        elList.forEach((el) => el.blur());
      }
      return Reflect.apply(target, object, args);
    },
  });
};

export default {
  install(application) {
    const loading = application.config.globalProperties.$loading;
    // eslint-disable-next-line no-param-reassign
    application.config.globalProperties.$loading = (params) => loading({
      fullscreen: true,
      background: 'rgba(0,0,0,.15)',
      ...params,
    });
    const {
      $msgbox,
      $alert,
      $confirm,
      $prompt,
      $message,
      $notify,
      $loading,
    } = application.config.globalProperties;
    application.provide('$msgbox', blurWrapper($msgbox));
    application.provide('$alert', blurWrapper($alert));
    application.provide('$confirm', blurWrapper($confirm));
    application.provide('$prompt', blurWrapper($prompt));
    application.provide('$message', blurWrapper($message));
    application.provide('$notify', blurWrapper($notify));
    application.provide('$loading', $loading);
  },
};
